import React, { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import { fetchAllProductInteractionCounts } from "../../services/Spice";
import { getAllProductsByCategory } from "../../services/productServices";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import Spinner from "../shared/Spinner";

// Register the chart components
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

function ViewByProduct() {
  const [interactionData, setInteractionData] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getInteractionData = async () => {
      try {
        const categoryName = "Spice & Herbs / ቅመማ ቅመሞቾ";
        const categoryProducts = await getAllProductsByCategory(categoryName);
        const productNames = (categoryProducts || []).map((p) => p.name);

        const allProductCounts = await fetchAllProductInteractionCounts();
        const productCounts = productNames.reduce((acc, name) => {
          acc[name] = 0;
          return acc;
        }, {});

        Object.values(allProductCounts).forEach((counts) => {
          counts.forEach(({ product_name, interactionCount }) => {
            if (product_name && productCounts[product_name] !== undefined) {
              productCounts[product_name] += interactionCount;
            }
          });
        });

        const sortedCounts = productNames
          .map((name, index) => ({
            name,
            index,
            count: productCounts[name] || 0,
          }))
          .sort((a, b) =>
            b.count === a.count ? a.index - b.index : b.count - a.count
          );

        setInteractionData(
          Object.fromEntries(sortedCounts.map((item) => [item.name, item.count]))
        );
      } catch (error) {
        console.error("Error fetching interaction data:", error);
      } finally {
        setLoading(false);
      }
    };

    getInteractionData();
  }, []);

  const chartData = {
    labels: Object.keys(interactionData),
    datasets: [
      {
        label: "Interactions",
        data: Object.values(interactionData),
        backgroundColor: [
          "rgba(255, 99, 132, 0.8)",
          "rgba(54, 162, 235, 0.8)",
          "rgba(255, 206, 86, 0.8)",
          "rgba(75, 192, 192, 0.8)",
          "rgba(153, 102, 255, 0.8)",
          "rgba(255, 159, 64, 0.8)",
          "rgba(99, 255, 132, 0.8)",
          "rgba(255, 99, 255, 0.8)",
          "rgba(54, 235, 235, 0.8)",
        ],
        borderColor: [
          "rgba(255, 99, 132, 1)",
          "rgba(54, 162, 235, 1)",
          "rgba(255, 206, 86, 1)",
          "rgba(75, 192, 192, 1)",
          "rgba(153, 102, 255, 1)",
          "rgba(255, 159, 64, 1)",
          "rgba(99, 255, 132, 1)",
          "rgba(255, 99, 255, 1)",
          "rgba(54, 235, 235, 1)",
        ],
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "top",
      },
      title: {
        display: true,
        text: "Number of Interactions by Product",
      },
    },
    plugins: {
      // Configure data labels
      datalabels: {
        anchor: "end",
        align: "end",
        formatter: (value) => Math.round(value), // Format as integer (no decimal places for view counts)
        color: "#000", // Color of the text
        font: {
          weight: "bold",
        },
      },
    },
  };

  if (loading) {
    return (
      <div className="relative min-h-[calc(100vh-8rem)] flex items-center justify-center">
        <Spinner size="xl" fullScreen={true} />
      </div>
    );
  }

  return (
    <div style={{ height: "300px", width: "100%" }}>
      <Bar data={chartData} options={options} />
    </div>
  );
}

export default ViewByProduct;
